<template>
  <div class="document-container">
    <div class="columns">
      <div class="column">
        <!-- Configuration Manager Header with Tabs -->
        <configuration-manager-header ref="header" class="document"/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <router-view name="configurationManagerSelection"/>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigurationManagerHeader from '@/components/ConfigurationManagerHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

export default {
  mixins: [
    BreadcrumbsManager,
  ],
  components: {
    ConfigurationManagerHeader,
  },
  created() {
    this.setBreadcrumb([
      { text: 'Configuration Manager', to: { } },
    ]);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(evt) {
      const { header } = this.$refs;
      const { tabs } = header.$refs;
      if (evt.key === 'Tab' && tabs.selectedIndex < 0) {
        evt.preventDefault();
        tabs.focusOption();
      }
    },
  },
};

</script>

<style lang="sass" scoped>
</style>
